import React from 'react';
import { Link } from 'react-router-dom';
import './DestinationTours.css';

function DestinationTours({ destination }) {
  // In a real app, this would filter tours from the tours.json file
  // For now, showing a placeholder
  const relatedTours = [
    {
      id: 1,
      name: 'Serengeti Safari Adventure',
      duration: '5 days',
      price: '$1,200',
      image: '/assets/imgs/destination/serengeti1.jpg'
    },
    {
      id: 2,
      name: 'Ngorongoro Crater Experience',
      duration: '3 days',
      price: '$850',
      image: '/assets/imgs/destination/ngorongoro1.jpg'
    }
  ];

  return (
    <section className="destination-tours-section">
      <div className="destination-tours-container">
        <h2 className="destination-tours-title">Related Tours</h2>
        <p className="destination-tours-subtitle">
          Explore this destination with our carefully crafted tour packages
        </p>
        <div className="destination-tours-grid">
          {relatedTours.map((tour) => (
            <div key={tour.id} className="destination-tour-card">
              <div className="tour-card-image">
                <img src={tour.image} alt={tour.name} />
              </div>
              <div className="tour-card-content">
                <h3 className="tour-card-name">{tour.name}</h3>
                <div className="tour-card-info">
                  <span className="tour-duration">{tour.duration}</span>
                  <span className="tour-price">{tour.price}</span>
                </div>
                <Link to="/trips" className="tour-card-btn">
                  View Tour Details
                </Link>
              </div>
            </div>
          ))}
        </div>
        <div className="destination-tours-cta">
          <Link to="/trips" className="btn btn-primary">
            View All Tours
          </Link>
        </div>
      </div>
    </section>
  );
}

export default DestinationTours;

